import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const GeneralIncidentsPerZone = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="ZONE"  disaggregation = "validity"/>
        </>
    
  )
}

export default GeneralIncidentsPerZone